// extracted by mini-css-extract-plugin
export default {"errorMessage":"liner-material-delete-modal-module__errorMessage--WSXgB"};